import { useDataStore } from '@/pinia'
import type { App, DirectiveBinding } from 'vue'

interface ClickOutsideHTMLElement extends HTMLElement {
  clickOutsideEvent?: (event: MouseEvent) => void
}

export default {
  install: (app: App) => {
    app.directive('click-outside', ClickOutside)
    app.directive('key', KeyController)
  },
}

export const ClickOutside = {
  mounted: function (el: ClickOutsideHTMLElement, binding: DirectiveBinding) {
    el.clickOutsideEvent = function (event: MouseEvent) {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event, el)
      }
    }
    setTimeout(() => {
      document.addEventListener('click', el.clickOutsideEvent!)
    }, 100)
  },
  unmounted: function (el: ClickOutsideHTMLElement) {
    document.removeEventListener('click', el.clickOutsideEvent!)
  },
}

export const KeyController = {
  mounted: function (el: HTMLElement, binding: DirectiveBinding) {
    const list = useDataStore().getPermissionList
    if (!list.includes(binding.value) && binding.value !== null) {
      el.remove()
    }
  },
}
